// extracted by mini-css-extract-plugin
export default {"productcard":"GF","productimage":"HF","username":"IF","multiBagName":"JF","productinfo":"KF","productinfoinner":"LF","productname":"MF","productsubheader":"NF","productdescription":"OF","productnumbers":"PF","productnumberstitle":"QF","productnumbersitem":"RF","number":"SF","numbertext":"TF","tabs":"UF","benefitsblock":"VF","benefit":"WF","benefitname":"XF","benefitdescription":"YF","ingredientsblock":"ZF","tipsblock":"aG","mobileonly":"bG"};
    if(module.hot) {
      // 1738064241676
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  